import React, {Fragment, useEffect} from 'react';
import { useDispatch } from 'react-redux';
import { Card, CardContent } from '@mui/material';
import { setearDatosAlStore } from 'store/actions/customAction';
import { nombreDeAcciones } from 'constantes/nombreDeAcciones';
import ListadoPersonaIndividual from './ListadoPersonaIndividual';
import PersonaLegal from './PersonaLegal';

const DatosDelPropietario= ({activeStep, numberStep, datosDeEmpresa, listadoPersonaIndividual, personaLegal, idSolicitud={idSolicitud}}) => {

    const dispatch = useDispatch()
    useEffect(() => {
        validarTipoDePropietario(datosDeEmpresa.tipoPropietario)
    }, []);

    const validarTipoDePropietario = (tipoPropietario) => {
        if(tipoPropietario === '1') dispatch(setearDatosAlStore({ dispatchAction : nombreDeAcciones.CLEAN_DATA_LEGAL_PERSON, }));
        else dispatch(setearDatosAlStore({ dispatchAction : nombreDeAcciones.CLEAN_DATA_PERSON_ISSUING_THE_INVOICE,  }));
    }

    return (
        <Fragment>
            <Card>
                <CardContent>
                    {datosDeEmpresa.tipoPropietario === '1' ? ( <ListadoPersonaIndividual activeStep={activeStep} numberStep={numberStep} listadoPersonaIndividual={listadoPersonaIndividual} idSolicitud={idSolicitud} />  )
                    : (  <PersonaLegal activeStep={activeStep} numberStep={numberStep} personaLegal={personaLegal} idSolicitud={idSolicitud} /> ) }
            </CardContent>
            </Card>
        </Fragment>
    );
}

export default DatosDelPropietario;